import { render } from "./LanguageBannerAtom.vue?vue&type=template&id=56599fa0&scoped=true"
import script from "./LanguageBannerAtom.vue?vue&type=script&lang=js"
export * from "./LanguageBannerAtom.vue?vue&type=script&lang=js"

import "./LanguageBannerAtom.vue?vue&type=style&index=0&id=56599fa0&scoped=true&lang=css"

import exportComponent from "D:\\a\\utslappstoppen\\utslappstoppen\\utslappstoppen.app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56599fa0"]])

export default __exports__